<template>
  <div>
    <v-speed-dial v-model="fab" fixed right open-on-hover direction="top" style="bottom: 60px">
      <template v-slot:activator>
        <v-btn v-model="fab" color="grey darken-1" dark fab>
          <v-icon v-if="fab">mdi-close</v-icon>
          <v-icon v-else>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-btn v-if="!download && !isClient && create" fab class="white--text" color="primary" :disabled="disabled" @click="click()">
        <v-icon>{{ icon }}</v-icon>
      </v-btn>
      <slot></slot>
    </v-speed-dial>
  </div>
</template>

<script>

export default {
  name: 'floating-button',
  props: {
    download: { type: Boolean, default: false },
    save: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    create: { type: Boolean, default: true }
  },
  data: () => ({
    fab: false,
  }),
  computed: {
    isClient () {
      return this.$store.getters['IS_CLIENT']
    },
    icon () {
      return this.save ? 'mdi-content-save-outline' : 'mdi-plus'
    },
  },
  methods: {
    click (){
      this.$emit('click')
    }
  }
};
</script>
